import styled from "styled-components";
import { useState, useEffect } from "react";
import FormStringInput from "../../../../../components/FormControls/FormStringInput";
import FormNumberInputHorizontal from "../../../../../components/FormControls/FormNumberInputHorizontal";
import PrimaryButton from "../../../../../components/FormControls/PrimaryButton";
import SecondaryButton from "../../../../../components/FormControls/SecondaryButton";
import request from "../../../../../api/request";
import { updateObject } from "../../../../../utils/object";
import { NotificationManager } from 'react-notifications';

const StyledLoginSettings = styled.div`
    margin-left: 30px;
`;

const SettingsBoard = styled.div`
    background-color: white;
    width: 755px;
    box-sizing: border-box;
    min-height: 136px;
    padding: 30px;
    margin-bottom: 30px;
    color: ${(props) => props.theme.color.gray};
`;

const Title = styled.span`
    display: block;
    color: ${(props) => props.theme.color.primaryblue};
    font-size: 14px;
    font-weight: 600;
    padding-bottom: 5px;
`;

function LoginSettings(props) {

    const [isSaving, setIsSaving] = useState(false);
    const [minPasswordLength, setMinPasswordLength] = useState(6);
    const [minAlphabeticCharacters, setMinAlphabeticCharacters] = useState(2);
    const [minNumericCharacters, setMinNumericCharacters] = useState(1);
    const [generatedPassword, setGeneratedPassword] = useState('');
    const [minLoginAttempts, setMinLoginAttempts] = useState(5);

    const onSaveChanges = async () => {
        setIsSaving(true);
        let saveData = {
            MinPasswordLength: minPasswordLength,
            MinAlphaLength: minAlphabeticCharacters,
            MinNumericLength: minNumericCharacters,
            MaxLoginAttempts: minLoginAttempts
        }
        const resp = (await request('database', 'saveSettings', [saveData]));
        if (resp.ok) {
            updateObject(props.settings, saveData);
            props.setSettings(props.settings);
            NotificationManager.success('Login settings saved');
        } else
        {
            console.log(resp.data);
            NotificationManager.error(resp.data);
        }
        setIsSaving(false);
    };

    const generateAlphabeticPassword = (len) => {
        const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
        let alphabeticPassword = '';
        for (let i = 0; i < len; i ++) {
            alphabeticPassword += letters[Math.floor(Math.random() * letters.length)]
        }
        return alphabeticPassword;
    }

    const generateNumericPassword = (len) => {
        const numbers = '0123456789';
        let numericPassword = '';
        for (let i = 0; i < len; i ++) {
            numericPassword += numbers[Math.floor(Math.random() * numbers.length)]
        }
        return numericPassword;
    }

    // const generateSymbolicPassword = (len) => {
    //     const symbols = "!@#$%^&*()_+=";
    //     let symbolicPassword = '';
    //     for (let i = 0; i < len; i ++) {
    //         symbolicPassword += symbols[Math.floor(Math.random() * symbols.length)]
    //     }
    //     return symbolicPassword;
    // }

    const generateRandomPassword = (len) => {
        const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";// + "!@#$%^&*()_+=";
        let randomPassword = '';
        for (let i = 0; i < len; i ++) {
            randomPassword += characters[Math.floor(Math.random() * characters.length)]
        }
        return randomPassword;
    }

    const mixPassword = (password) => {
        let a = password.split(""),
        n = a.length;

        for(let i = n - 1; i > 0; i--) {
            let j = Math.floor(Math.random() * (i + 1));
            let tmp = a[i];
            a[i] = a[j];
            a[j] = tmp;
        }
        return a.join("");
    }
    
    const onGeneratePassword = () => {
        let password = ''

        if (minAlphabeticCharacters > 0) {
            password += generateAlphabeticPassword(minAlphabeticCharacters);
        }
        if (minNumericCharacters > 0) {
            password += generateNumericPassword(minNumericCharacters);
        }
        if (minPasswordLength > minAlphabeticCharacters + minNumericCharacters) {
            password += generateRandomPassword(minPasswordLength - minAlphabeticCharacters - minNumericCharacters);
        }
        password = mixPassword(password);
        
        setGeneratedPassword(password);
    };

    useEffect(() => {
        props.setPageTitle('Login details');
        setMinPasswordLength(props.settings.MinPasswordLength || 6);
        setMinAlphabeticCharacters(props.settings.MinAlphaLength || 1);
        setMinNumericCharacters(props.settings.MinNumericLength || 1);
        setMinLoginAttempts(props.settings.MaxLoginAttempts || 5);
    }, [])
    
    return (
        <StyledLoginSettings>
            <SettingsBoard>
                <Title>Password validation</Title>
                <FormNumberInputHorizontal label='Minimum password length' value={minPasswordLength} min='1' onChange={setMinPasswordLength} labelStyle={{marginRight: 'auto'}} inputStyle={{width: 85}} style={{width: 315, paddingTop: 10}}></FormNumberInputHorizontal>
                <FormNumberInputHorizontal label='Minimum alphanumeric characters' value={minAlphabeticCharacters} min='0' onChange={setMinAlphabeticCharacters} labelStyle={{marginRight: 'auto'}} inputStyle={{width: 85}} style={{width: 315, paddingTop: 10}}></FormNumberInputHorizontal>
                <FormNumberInputHorizontal label='Minimum numeric characters' value={minNumericCharacters} min='0' onChange={setMinNumericCharacters} labelStyle={{marginRight: 'auto'}} inputStyle={{width: 85}} style={{width: 315, paddingTop: 10}}></FormNumberInputHorizontal>
                <div style={{display: 'flex', width: 315, paddingBottom: 25}}>
                    <SecondaryButton caption='Test password generator' onClick={onGeneratePassword} style={{marginTop: 'auto'}}></SecondaryButton>
                    <FormStringInput placeholder='' inputStyle={{width: 125}} value={generatedPassword} onChange={setGeneratedPassword} style={{marginLeft: 'auto'}}></FormStringInput>
                </div>
            </SettingsBoard>
            <SettingsBoard>
                <Title>Login restrictions</Title>
                <div style={{display: 'flex'}}>
                    <FormNumberInputHorizontal label='Maximum login attempts' value={minLoginAttempts} min='1' onChange={setMinLoginAttempts} labelStyle={{marginRight: 'auto'}} inputStyle={{width: 85}} style={{width: 315}}></FormNumberInputHorizontal>
                </div>
            </SettingsBoard>
            <div style={{float: 'right'}}><PrimaryButton caption='Save changes' isLoading={isSaving} onClick={onSaveChanges}></PrimaryButton></div>
        </StyledLoginSettings>
    )
}

export default LoginSettings;